//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import {
    APP_DATE_DOT_FORMAT,
    APP_DATE_HOUR_MIN_FORMAT
} from "@/assets/js/appConfig";
import FabricSearch from "@/components/q-fabric-search.vue";
import { eventBus,
    setPluginIconColor,
    formatTimeToSend } from "@/assets/js/appFunc";

import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import PIApiModal from "../PIApiModal.vue";
import TabContent from "./TabContent.vue";
import TabComponents from "../mixins/tab-components";

export default {
    components: {
        TabContent,
        PIApiModal,
        FabricSearch,
        AQInput,
        AQCard,
        AQButton
    },
    filters: {},
    mixins: [TabComponents],
    props: {
        instanceID: {
            type: String,
            default: ""
        },
        instanceName: {
            type: String,
            default: ""
        },
        systemStatus: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            mode: "blc",
            APP_DATE_HOUR_MIN_FORMAT,
            APP_DATE_DOT_FORMAT,
            showClearIconFrom: true,
            showClearIconTo: true,
            blockchain: {},
            blockchainPayLoad: {
                dateFrom: "",
                dateTo: "",
                generalSearch: "",
                page: 0,
                size: 5,
                sortDirection: "DESC",
                sortField: "execStartDate",
                processInstanceId: this.instanceID
            },
            blockchainList: [],
            showProcessInformationBlockchainModal: false,
            toDateBlockchain: "",
            fromDateBlockchain: "",
            noFromDateBlockchainFound: false,
            noToDateBlockchainFound: false,
            searchBlockchain: "",
            showLoadMoreBlkBtn: false,
            blockchainListExists: true
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        blockchainModalProps() {
            return {
                api: this.blockchain,
                instanceStatus: this.systemStatus,
                instanceName: this.instanceName,
                instanceID: this.instanceID,
                blockchain: true
            };
        }
    },
    watch: {
        toDateBlockchain: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "toStartDateBlockchain");
            }
        },
        fromDateBlockchain: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "fromStartDateBlockchain");
            }
        }
    },
    beforeDestroy() {
        eventBus.$off("blockchainRefreshTab");
    },
    mounted() {
        this.blockchainDetailsCall();
        eventBus.$on("blockchainRefreshTab", () => {
            this.blockchainDetailsCall();
        });
    },
    methods: {
        setPluginIconColor,
        formatTimeToSend,
        ...mapActions("admin", [
            "getBlockchainDetails",
            "getProcessInspectorInformation"
        ]),
        openApiModal(api) {
            this.showProcessInformationApiModal = true;
            this.api = api;
        },
        openBlockchainModal(blockchain) {
            this.showProcessInformationBlockchainModal = true;
            this.blockchain = blockchain;
        },
        blockchainDetailsCall(loadMore) {
            if (!loadMore) {
                this.blockchainPayLoad.page = 0;
            }
            this.getBlockchainDetails(this.blockchainPayLoad).then(data => {
                this.blockchainList = loadMore ? this.blockchainList.concat(data.data.list) : data.data.list;
                this.showLoadMoreBlkBtn = this.blockchainPayLoad.size * (this.blockchainPayLoad.page + 1) < data.data.totalElements;
                this.blockchainListExists = data.data.list && data.data.list.length;
            });
        },
        searchTermDataBlockchain(value) {
            this.blockchainPayLoad.generalSearch = value;
            this.blockchainPayLoad.size = 5;
            this.blockchainDetailsCall();
        },
        loadMoreItems() {
            ++this.blockchainPayLoad.page;
            this.blockchainDetailsCall(true);
        },
        showClearIconFunc(value, state) {
            if (state === "fromStartDateBlockchain") {
                this.showClearIconFrom = !!value;
            } else if (state === "toStartDateBlockchain") {
                this.showClearIconTo = !!value;
            }
        },
        updateDate(value) {
            const fromDate = this.fromDateBlockchain;
            const toDate = this.toDateBlockchain;
            const payload = this.blockchainPayLoad;
            if (value) {
                if (fromDate && toDate) {
                    this.noToDateBlockchainFound = false;
                    this.noFromDateBlockchainFound = false;
                    payload.dateFrom = this.formatTimeToSend(
                        fromDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.dateTo = this.formatTimeToSend(
                        toDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.size = 5;
                    this.blockchainDetailsCall();
                } else if (!fromDate && toDate) {
                    this.noFromDateBlockchainFound = true;
                } else if (fromDate && !toDate) {
                    this.noToDateBlockchainFound = true;
                }
            }
        },
        updateModel(isFrom) {
            const fromDate = this.fromDateBlockchain;
            const toDate = this.toDateBlockchain;
            if (isFrom) {
                this.fromDateBlockchain = "";
                if (toDate) {
                    this.noFromDateBlockchainFound = true;
                    this.noToDateBlockchainFound = false;
                } else {
                    this.noToDateBlockchainFound = false;
                    this.setPayloadOnUpdateModel();
                }
            } else {
                this.toDateBlockchain = "";
                if (fromDate) {
                    this.noFromDateBlockchainFound = false;
                    this.noToDateBlockchainFound = true;
                } else {
                    this.noFromDateApiFound = false;
                    this.setPayloadOnUpdateModel();
                }
            }
        },
        setPayloadOnUpdateModel() {
            this.noFromDateBlockchainFound = false;
            this.blockchainPayLoad.dateFrom = "";
            this.blockchainPayLoad.dateTo = "";
            this.blockchainPayLoad.size = 5;
            this.blockchainDetailsCall();
        }
    }
};
